// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-issue-seller-registration-repwise-indetail-report',
//   standalone: true,
//   imports: [],
//   templateUrl: './issue-seller-registration-repwise-indetail-report.component.html',
//   styleUrl: './issue-seller-registration-repwise-indetail-report.component.scss'
// })
// export class IssueSellerRegistrationRepwiseIndetailReportComponent {

// }

import { Component, Inject } from '@angular/core';
// import { RegistrationReportComponent } from '../registration-report/registration-report.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import * as XLSX from 'xlsx';
import { RegistrationReportComponent } from '../pages/registration-report/registration-report.component';

@Component({
  selector: 'app-issue-seller-registration-repwise-indetail-report',
  standalone: false,
  templateUrl: './issue-seller-registration-repwise-indetail-report.component.html',
  styleUrl: './issue-seller-registration-repwise-indetail-report.component.scss'
})
export class IssueSellerRegistrationRepwiseIndetailReportComponent {
  isLoading: boolean = false;
  type;
  start_date = '';
  end_date = '';
  rep_name = '';
  off_rep_name = '';
  issue_cat = '';
  issue_date = '';
  newindetails: boolean = false;
  indetail: boolean = false;
  brfly: boolean = false;
  verybrfly: boolean = false;
  datewise: boolean = false;
  officerep: boolean = false;
  inDetailsRegReport = [];
  inDetailsRegReportTotal = {
    total_advt: 0,
    advt_total: 0,
    net_amt: 0,
    gst: 0,
    total_amt: 0,
    rcvd_amt: 0,
    pndg_amt: 0,
  };
  inDetailsOffRegReportTotal = {
    total_advt: 0,
    advt_total: 0,
    net_amt: 0,
    gst: 0,
    total_amt: 0,
    rcvd_amt: 0,
    pndg_amt: 0,
  };
  categoryNameForHTML: any;
  issueNameForHTML: any;

   constructor(
      private dialogref: MatDialogRef<RegistrationReportComponent>,
      private datePipe: DatePipe,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private service: DigisubservicesService
    ) {}
    newissuedatepp:any
    ngOnInit(): void {
       this.type = this.data['type'];
      this.start_date = this.data['start_date'];
      this.end_date = this.data['end_date'];
      this.rep_name = this.data['rep_name'];
      this.off_rep_name = this.data['off_rep_name'];
      this.newissuedatepp = this.data['newissuedatepp'];
    
      this.issue_cat = this.data['issue_cat'] === undefined ? "ALL" : this.data['issue_cat'];
    
      // Extract only the date part (before first comma)
      const issueDateRaw = this.data['issueDates'];
      if (Array.isArray(issueDateRaw) && issueDateRaw.length > 0) {
        this.issue_date = issueDateRaw[0].split(',')[0];
      } else {
        this.issue_date = "ALL";
      }
    
      console.log("Final Payload Data:", {
        representativeId: this.rep_name,
        startDate: this.start_date,
        endDate: this.end_date,
        officeRepresentativeId: this.off_rep_name,
        issueNameId: this.issue_cat,
        issueSellerDate: this.issue_date
      });
    
      this.getRegrepwiseindetailReportData();
    };
    filteredinDetailsRegReport:any
    showindetail: boolean = false;
    totalAmounts = {
      total_amount: 0,
      net_amount: 0,
      without_gst_amount: 0,
      issue_selling_amount: 0,
      issue_selling_discount_amt: 0,
      with_gst_amount: 0,
      issue_seller_price:0,
      gst_amount:0,
      issue_seller_copies:0,
      rcvamount:0
    };
   getRegrepwiseindetailReportData() {
  const issuesellerbooking = {
    representativeId: this.rep_name,
    startDate: this.start_date,
    endDate: this.end_date,
    officeRepresentativeId: this.off_rep_name,
    issueNameId: this.issue_cat,
    issueSellerDate: this.issue_date
  };

  // Reset totals before aggregation
  this.totalAmounts = {
    total_amount: 0,
    net_amount: 0,
    without_gst_amount: 0,
    issue_selling_amount: 0,
    issue_selling_discount_amt: 0,
    with_gst_amount: 0,
    issue_seller_price: 0,
    gst_amount: 0,
    issue_seller_copies: 0,
    rcvamount: 0
  };

  this.service.getIssueSellerRegrepwiseindetailReportList(issuesellerbooking).subscribe((data) => {
    this.filteredinDetailsRegReport = data;
      this.categoryNameForHTML=this.filteredinDetailsRegReport[0].issue_category_id
        this.issueNameForHTML=this.filteredinDetailsRegReport[0].issuename
    console.log(this.filteredinDetailsRegReport);

    // Iterate through representative groups
    this.filteredinDetailsRegReport.forEach(rep => {
      // Iterate through each issue record
      rep.issue_data.forEach(item => {
        this.totalAmounts.total_amount += item.issue_seller_amt ? parseFloat(item.issue_seller_amt) : 0;
        this.totalAmounts.issue_seller_price += item.issue_seller_price ? parseFloat(item.issue_seller_price) : 0;
        this.totalAmounts.net_amount += item.net_amount ? parseFloat(item.net_amount) : 0;
        this.totalAmounts.without_gst_amount += item.without_gst_amount ? parseFloat(item.without_gst_amount) : 0;
        this.totalAmounts.issue_selling_amount += item.issue_selling_amount ? parseFloat(item.issue_selling_amount) : 0;
        this.totalAmounts.issue_selling_discount_amt += item.issue_seller_discount ? parseFloat(item.issue_seller_discount) : 0;
        this.totalAmounts.with_gst_amount += item.with_gst_amount ? parseFloat(item.with_gst_amount) : 0;
        this.totalAmounts.issue_seller_copies += item.issue_copies ? parseFloat(item.issue_copies) : 0;
        this.totalAmounts.rcvamount += item.entry_amt ? parseFloat(item.entry_amt) : 0;

        // Calculate GST amount from with and without GST
        const gstAmt = (item.with_gst_amount ? parseFloat(item.with_gst_amount) : 0) -
                       (item.without_gst_amount ? parseFloat(item.without_gst_amount) : 0);
        this.totalAmounts.gst_amount += gstAmt;
      });
    });
  });
}
getRepresentativeTotals(issueData: any[], field: string): number {
  return issueData.reduce((total, item) => total + (Number(item[field]) || 0), 0);
}




    
      exportExcel(fileName) {
        /* table id is passed over here */
        let element = document.getElementById('print-section');
        const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    
        /* save to file */
        XLSX.writeFile(wb, fileName + '.xlsx');
      }
      print() {
        const originalTitle = document.title; // Store original title
        document.title = '';     // Set custom print title
      
        // Create a style tag for print-specific styles
        const style = document.createElement('style');
        style.innerHTML = `
          @media print {
            @page {
              size: A4;
              margin: 10mm;
            }
            .print-header {
              text-align: center;
              font-size: 16px;
              font-weight: bold;
              margin-bottom: 10px;
            }
            .print-footer {
              position: fixed;
              bottom: 10px;
              left: 0;
              right: 0;
              text-align: center;
              font-size: 12px;
              color: gray;
            }
            .print-footer::after {
              content: "Page " counter(page) " of " counter(pages);
            }
            .no-print {
              display: none !important;
            }
          }
        `;
      
        document.head.appendChild(style); // Add style to the document
      
        setTimeout(() => {
          const printTrigger = document.getElementById('print-button');
          if (printTrigger) (printTrigger as HTMLElement).click();
          
          document.title = ''; // Restore original title after printing
          
          // document.head.removeChild(style); // Remove the style after printing
        }, 500); // Delay ensures styles apply before printing
      }
    //  this. getReportData();

    rep_type:any
    getdatabydep:any
    assignoffwithtype(){
    
      this.rep_type = "issue"
  
      this.service.getListofassignrep(this.rep_type).subscribe((data) => {
        this.getdatabydep = data;
        console.log(this.getdatabydep)
      });
      
    }

    
}

